var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.558,
    height: 68.558,
    viewBox: "0 0 68.558 68.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .help-a,.help-b,.help-c{fill:none;stroke:#3eb3a9;stroke-linecap:round;stroke-width:3px;}.help-a,.help-b{stroke-linejoin:round;}.help-a{stroke-dasharray:118\n      28;}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.082 2.082)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "help-a",
    d: "M46.385,23.193A23.193,23.193,0,1,1,23.193,0,23.193,23.193,0,0,1,46.385,23.193Z",
    transform: "translate(64.394 25.938) rotate(124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "help-b",
    d: "M19.146,25.146h0",
    transform: "translate(13.051 24.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "help-c",
    d: "M14.032,23.408A6.375,6.375,0,0,1,15.7,18.251c2.146-2.068,9.5-2.555,7.661-9.222S8.892.3,4.832,9.03",
    transform: "translate(18.19 15.554)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.10f1820e8f35f0082f89b3499595ca32.svg";
export { ForwardRef as ReactComponent };